<template>
  <div class="z-card">
    <img
      :src="require('assets/images/onboarding/payment.svg')"
      class="next-bills__illustration spacer-bottom-xl"
    >

    <p class="z-title z-title--small z-title--center spacer-bottom-s">
      {{ this.title }}
    </p>

    <p class="z-text z-text--large z-text--center">
      {{ this.description }}
    </p>
  </div>
</template>

<style lang="scss" scoped>

.next-bills__illustration {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 250px;
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Sem mensalidades disponíveis',
    },
    description: {
      type: String,
      default: 'Assim que estiverem disponíveis, elas aparecerão nessa tela.',
    },
  },
};
</script>
